import { PostHogProvider as PHProvider } from 'posthog-js/react';
import { useEffect } from 'react';
import type { ReactNode } from 'react';

import { posthog, initPostHog } from './posthog';
import { env } from '../../env';

export function PostHogProvider({ children }: { children: ReactNode }) {
  useEffect(() => {
    initPostHog();
  }, []);

  if (!env.POSTHOG_KEY) {
    return <>{children}</>;
  }

  return <PHProvider client={posthog}>{children}</PHProvider>;
}
